<template>
  <button class="sns-button-wrapper" @click="getAppleToken">
    <slot></slot>
  </button>
</template>

<script setup>
  import { onMounted } from 'vue'
  import { useRoute } from 'vue-router/composables'
  import { setLibFile } from '@/common/utils/common'
  import cookie from '@/common/utils/cookie'
  import constant from '@/common/resources/constant'

  const route = useRoute()
  const emit = defineEmits(['success', 'fail'])

  const getAppleToken = () => {
    AppleID.auth.init({
      clientId: 'kr.co.captv.pooqV2.member',
      scope: 'email',
      redirectURI: 'https://member.wavve.com/mobile/signup/mweb/apple',
      // response
      state: '',
      usePopup: false, // or false defaults to false
    })
    cookie.setItem(
      'w-apple-login-return-url',
      location.href,
      null,
      constant.URL_COOKIE_DOMAIN,
      '/',
    )
    AppleID.auth.signIn()
  }

  const init = () => {
    setLibFile(
      document,
      'script',
      'apple-login',
      '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/ko_KR/appleid.auth.js',
    )

    const { type, token } = route.query
    if (type === 'apple' && token) {
      emit('success', { token })
    }
  }

  onMounted(() => {
    init()
  })
</script>
